export function throttle<T>(
  func: (this: T, ...args: any[]) => void,
  limit: number,
) {
  let lastFunc: NodeJS.Timeout;
  let lastRan: number;
  return function (this: T, ...args: any[]) {
    if (!lastRan) {
      func.apply(this, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(
        () => {
          if (Date.now() - lastRan >= limit) {
            func.apply(this, args);
            lastRan = Date.now();
          }
        },
        limit - (Date.now() - lastRan),
      );
    }
  };
}
// Usage
// const throttledFunction = throttle(() => console.log('Throttled!'), 300);

export function debounce<T>(
  func: (this: T, ...args: any[]) => void,
  delay: number,
) {
  let timeoutId: NodeJS.Timeout;
  return function (this: T, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

// Usage
// const debouncedFunction = debounce(() => console.log('Debounced!'), 300);
